import {getSixMathRandom} from "./handMath";
import {ALI_OSS_PATH} from "./constants";
import {message} from "antd";
import {getAliOssTokenRequest} from "../features/HomePage/HomePageApi";
import OSS from "ali-oss";
let client;
let clientExpTime;
export function getAliOssToken() {
    let nowDate = new Date().getTime()
    if (!client||nowDate - clientExpTime>1200000) {
        clientExpTime = new Date().getTime();
        getAliOssTokenRequest((data) => {
            if ("Credentials" in data) {
                client = new OSS({
                    // yourRegion填写Bucket所在地域。以华东1（杭州）为例，Region填写为oss-cn-hangzhou。
                    region: 'oss-cn-qingdao',
                    // 从STS服务获取的临时访问密钥（AccessKey ID和AccessKey Secret）。
                    accessKeyId: data.Credentials.AccessKeyId,
                    accessKeySecret: data.Credentials.AccessKeySecret,
                    // 从STS服务获取的安全令牌（SecurityToken）。
                    stsToken: data.Credentials.SecurityToken,
                    refreshSTSToken: async () => {
                        // 向您搭建的STS服务获取临时访问凭证。
                        getAliOssTokenRequest((data) => {
                            return {
                                accessKeyId: data.Credentials.AccessKeyId,
                                accessKeySecret: data.Credentials.AccessKeySecret,
                                stsToken: data.Credentials.SecurityToken,
                            }
                        })

                    },
                    // 刷新临时访问凭证的时间间隔，单位为毫秒。
                    refreshSTSTokenInterval: 3000000,
                    // 填写Bucket名称。
                    bucket: 'tgnp'
                })
            }
        })
    }
}
// async function uploadAlioss(file) {
//     try {
//         // 使用阿里云OSS SDK上传文件
//         let timestamp = new Date().getTime()
//         let random = getSixMathRandom()
//         const result = await client.put(ALI_OSS_PATH+"user/" + timestamp + random + file.name, file);
//         return result.url.replace("http:","https:");
//     } catch (e) {
//         return '头像上传失败';
//     }
// }

export const uploadAlioss = async options => {
    const {file} = options;

    try {
        // 使用阿里云OSS SDK上传文件
        let timestamp = new Date().getTime()
        let random = getSixMathRandom()
        const result = await client.put(ALI_OSS_PATH+"user/" + timestamp + random + file.name, file);
        // file.url = result.url.replace("http:","https:");
        // onSuccess(file);
        return {
            "ret":'1',
            "url":  result.url.replace("http:","https:")
        }
    } catch (e) {
        message.error(`头像上传失败`);
        return {
            "ret":'0',
            "msg": e.message,
        }
        // onError(e);
    }
};